export enum ConsumerLoanLogMessageType {
        SMS = 0,
        Email
}
